<template>
  <div class="d-flex flex-column tw-mb-6">
    <h1 class="section-divider-underline">
      {{ $t("trainerProfile.skillLevelDetail") }}
    </h1>
    <div class="tw-overflow-auto tw-h-40" style="max-height: 50vh">
      <table class="tw-w-full">
        <thead>
          <tr class="tw-uppercase tw-bg-gray-200 tw-h-10 tw-sticky tw-top-0">
            <th class="tw-whitespace-nowrap tw-pl-2" style="width: 30%">
              {{ $t("trainerProfile.skillLevel") }}
            </th>
            <th class="tw-whitespace-nowrap" style="width: 30%">
              {{ $t("trainerProfile.availableInYear") }}
            </th>
            <th class="tw-whitespace-nowrap tw-text-center" style="width: 30%">
              {{ $t("trainerProfile.expireDate") }}
            </th>
            <th style="width: 5%" class="tw-text-center">
              <a
                href="#"
                @click.prevent="addRow"
                class="hover:tw-no-underline tw-text-right"
              >
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in model.skill_level_detail"
            :key="index"
            class="tw-cursor-pointer hover:tw-bg-gray-300 tw-w-full tw-h-10"
          >
            <td class="tw-whitespace-nowrap tw-pl-2">
              <select
                class="form-select"
                :placeholder="$t('trainerProfile.skillLevel')"
                v-model.number.trim="item.level_skill_id"
                :class="{
                  'is-invalid': errors.has(
                    'skill_level_detail.' + index + '.level_skill_id'
                  ),
                }"
              >
                <option
                  style="height: 40px"
                  v-for="(skill, index) in formViewDatas['levelSkills']"
                  :key="index"
                  :value="skill.level_skill_id"
                >
                  {{ skill.level_skill_name }} | Skill:
                  {{ skill.skill_name_en }}| LeveL:
                  {{ skill.skill_level_order }}
                  <span
                    v-if="skill.is_accessor"
                    class="badge bg-primary mr-2 tw-capitalize"
                  >
                    Accessor</span
                  >
                </option>
              </select>
            </td>
            <td class="tw-whitespace-nowrap">
              <input
                v-model.trim="item.available_in_year"
                :placeholder="$t('trainerProfile.availableInYear')"
                type="text"
                class="form-control"
              />
            </td>
            <td class="tw-whitespace-nowrap tw-text-center">
              <a-date-picker
                v-model="item.expire_date"
                style="width: 100%"
                placeholder="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                format="DD-MM-YYYY"
              />
            </td>
            <td class="tw-whitespace-nowrap tw-text-green-500 tw-text-center">
              <a
                href="#"
                :key="'a' + index"
                class="tw-text-right tw-text-red-600 hover:tw-text-red-600"
                @click.prevent="removeRow(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";

export default {
  name: "allowIp",
  props: ["value", "validation"],
  data() {
    return {
      model: {},
      errors: new Errors(),
    };
  },
  computed: {
    ...mapState("academic/trainerProfile", ["edit_data", "formViewDatas"]),
  },
  created() {
    this.model = this.value;
  },
  methods: {
    addRow() {
      this.model.skill_level_detail.push({
        level_skill_id: null,
        available_in_year: null,
        expire_date: null,
      });
    },
    removeRow(index) {
      this.model.skill_level_detail.splice(index, 1);
    },
    // onChangeExpire_date(dateString) {
    //   this.model.dob = dateString;
    // },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>
<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
